import React, { useEffect, useRef, useState } from "react";
import {
  makeStyles,
  Typography,
  Box,
  Grid,
  Button,
  Select,
  useMediaQuery,
  FormControl,
  MenuItem,
  useTheme,
  Container,
  CircularProgress,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useLocation, useHistory } from "react-router-dom";
import { useForm, Controller, useWatch } from "react-hook-form";
import Pagination from "@material-ui/lab/Pagination";
import moment from "moment";

import { propertyDataArray } from "../components/PropertyDataArray";
import Table from "../components/Table";
import { useAlert } from "../components/Alert";
import Text from "../components/Text";

const GET_FORECLOSURES = gql`
  query foreclosures(
    $obj_no: [Int]
    $obj_court: String
    $obj_str: String
    $obj_share: String
    $obj_caseno: String
    $obj_city: [String]
    $obj_area: [String]
    $obj_address: String
    $searchTerm: String
    $obj_date_ymd_from: Date
    $obj_date_ymd_to: Date
    $obj_creat_date_from: Date
    $obj_creat_date_to: Date
    $obj_build_floor_from: Float
    $obj_build_floor_to: Float
    $obj_price_from: Float
    $obj_price_to: Float
    $obj_type: String
    $obj_patterns: [String]
    $obj_time: [String]
    $obj_transfer: String
    $obj_land_data: String
    $obj_build_data: String
    $orderBy: OrderBy
    $desc: Boolean
    $pageSize: Int
    $frontSite: Boolean
    $page: Int
  ) {
    foreclosures(
      obj_no: $obj_no
      obj_court: $obj_court
      obj_str: $obj_str
      obj_share: $obj_share
      obj_caseno: $obj_caseno
      obj_city: $obj_city
      obj_area: $obj_area
      obj_address: $obj_address
      searchTerm: $searchTerm
      obj_date_ymd_from: $obj_date_ymd_from
      obj_date_ymd_to: $obj_date_ymd_to
      obj_creat_date_from: $obj_creat_date_from
      obj_creat_date_to: $obj_creat_date_to
      obj_build_floor_from: $obj_build_floor_from
      obj_build_floor_to: $obj_build_floor_to
      obj_price_from: $obj_price_from
      obj_price_to: $obj_price_to
      obj_type: $obj_type
      obj_patterns: $obj_patterns
      obj_time: $obj_time
      obj_transfer: $obj_transfer
      obj_land_data: $obj_land_data
      obj_build_data: $obj_build_data
      orderBy: $orderBy
      desc: $desc
      frontSite: $frontSite
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        obj_no
        obj_court
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_link
        obj_margin
        obj_price
        obj_price_set
        obj_creditor
        obj_debtor
        obj_bulletin_data
        obj_remark
        obj_land_data
        obj_build_data
        obj_land_floor
        obj_build_floor
        obj_add_floor
        obj_s_floor
        obj_c_floor
        obj_total_floor
        obj_transfer
        obj_type
        obj_creat_date
        obj_stop
        obj_tender_num
        obj_tender
        obj_check_num
        obj_stop_link
        obj_source
        obj_marker
        obj_coordinates
        obj_request_num
        obj_cadastral
        obj_patterns
        obj_sql
        obj_pyPDF
        phppdfjoin
        images {
          id
          imageUrl
        }
      }
    }
  }
`;

const GET_EXCLUSIVEPROPERTIES = gql`
  query exclusiveProperties(
    $franchiseStoreId: Int!
    $obj_city: String
    $obj_area: String
    $obj_type: String
    $enabled: Boolean
    $pageSize: Int
    $page: Int
  ) {
    exclusiveProperties(
      franchiseStoreId: $franchiseStoreId
      obj_city: $obj_city
      obj_area: $obj_area
      obj_type: $obj_type
      enabled: $enabled
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        obj_court
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_link
        obj_margin
        obj_price
        obj_price_set
        obj_creditor
        obj_debtor
        obj_bulletin_data
        obj_remark
        obj_land_data
        obj_build_data
        obj_land_floor
        obj_build_floor
        obj_add_floor
        obj_s_floor
        obj_c_floor
        obj_total_floor
        obj_transfer
        obj_type
        obj_creat_date
        obj_stop
        obj_tender_num
        obj_tender
        obj_check_num
        obj_stop_link
        obj_source
        obj_marker
        obj_coordinates
        obj_request_num
        obj_cadastral
        obj_patterns
        pricePerBuildPing
        pricePerLandPing
        obj_sql
        obj_pyPDF
        phppdfjoin
        errorLog
        lastEditedBy
        images {
          id
          imageUrl
        }
        imageHasCreated
        source
        name
        rent
        deposit
        managementFee
        monthOfManagementFee
        parkingSpace
        houseAge
        indoor_floor
        room
        hall
        bathroom
        orientation
        enable
      }
    }
  }
`;

const ADD_CHEACKNUMBER = gql`
  mutation addCheackNumber($id: Int!, $franchise: Boolean!) {
    addCheackNumber(id: $id, franchise: $franchise)
  }
`;

export default function SearchPropertyResult({
  data,
  searchType,
  franchise,
  onChangeTab = () => {},
}) {
  const history = useHistory();
  const Alert = useAlert();
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const isSmPhone = useMediaQuery("(max-width:480px)");
  const { courtArray } = propertyDataArray();
  const useStyles = makeStyles((theme) => ({
    itemButton: {
      display: "inline-block",
      width: "100%",
    },
    root: {
      width: "100%",
    },
    media: {
      height: 300,
    },
    cardTitle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 4,
      "-webkit-box-orient": "vertical",
    },
    select: {
      backgroundColor: "white",
      width: isPhone ? "auto" : "130px",
      minWidth: "100px",
      height: "22px",
      padding: "7px 24px 7px 10px",
      border: "1px solid black",
      borderRadius: "5px",
      "&:focus": {
        backgroundColor: "white",
        borderRadius: "5px",
      },
    },
  }));

  const classes = useStyles();
  const [newData, setNewData] = useState({
    page: 1,
    pageSize: 8,
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const { control, setValue, getValues } = useForm({
    defaultValues: {
      displayType: "一般模式",
      dataArray: [],
      pageCount: 0,
    },
  });
  const displayType = useWatch({ name: "displayType", control });
  const dataArray = useWatch({ name: "dataArray", control });
  const pageCount = useWatch({ name: "pageCount", control });
  const [getForeclosures, { loading }] = useLazyQuery(GET_FORECLOSURES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosures }) {
      if (foreclosures) {
        setValue("dataArray", foreclosures.contents);
        setValue("pageCount", foreclosures.pageCount);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  const [getExclusiveProperties, { loading: exclusivePropertiesLoading }] =
    useLazyQuery(GET_EXCLUSIVEPROPERTIES, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted({ exclusiveProperties }) {
        if (exclusiveProperties) {
          setValue("dataArray", exclusiveProperties.contents);
          setValue("pageCount", exclusiveProperties.pageCount);
        }
      },
      onError(error) {
        Alert.alert("通知", `${error}`, [
          {
            text: "確定",
            type: "ok",
          },
        ]);
      },
    });
  const [addCheackNumber, { loading: addCheackNumberLoading }] = useMutation(
    ADD_CHEACKNUMBER,
    {
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );
  function getCourt(value) {
    switch (value) {
      case "臺灣臺北地方法院":
        return "TPD";
      case "臺灣新北地方法院":
        return "PCD";
      case "臺灣士林地方法院":
        return "SLD";
      case "臺灣桃園地方法院":
        return "TYD";
      case "臺灣新竹地方法院":
        return "SCD";
      case "臺灣苗栗地方法院":
        return "MLD";
      case "臺灣臺中地方法院":
        return "TCD";
      case "臺灣南投地方法院":
        return "NTD";
      case "臺灣彰化地方法院":
        return "CHD";
      case "臺灣雲林地方法院":
        return "ULD";
      case "臺灣嘉義地方法院":
        return "CYD";
      case "臺灣臺南地方法院":
        return "TND";
      case "臺灣橋頭地方法院":
        return "CTD";
      case "臺灣高雄地方法院":
        return "KSD";
      case "臺灣屏東地方法院":
        return "PTD";
      case "臺灣臺東地方法院":
        return "TTD";
      case "臺灣花蓮地方法院":
        return "HLD";
      case "臺灣宜蘭地方法院":
        return "ILD";
      case "臺灣基隆地方法院":
        return "KLD";
      case "臺灣澎湖地方法院":
        return "PHD";
      case "福建金門地方法院":
        return "KMD";
      case "福建連江地方法院":
        return "LCD";

      default:
        break;
    }
  }
  //ANCHOR 查詢物件
  useEffect(() => {
    if (Boolean(data)) {
      if (franchise) {
        getExclusiveProperties({
          variables: {
            franchiseStoreId: 1,
            obj_city: data.district,
            obj_area: data.subdistrict ?? undefined,
            obj_type: (() => {
              switch (data.type.length) {
                case 1:
                  if (data.type.indexOf("土地") !== -1) return "L";
                  else if (data.type.indexOf("建物") !== -1) return "H";
                case 2:
                  return null;
                default:
                  break;
              }
            })(),
            enabled: true,
            pageSize: newData.pageSize,
            page: newData.page,
          },
        });
      } else {
        if (searchType.get("searchType") === "easy") {
          if (!data.district) return Alert.notice("縣市為必選！");
          getForeclosures({
            variables: {
              obj_city: data.district ? [data.district] : undefined,
              obj_area: data.subdistrict ? [data.subdistrict] : undefined,
              obj_type: (() => {
                switch (data.type.length) {
                  case 1:
                    if (data.type.indexOf("土地") !== -1) return "L";
                    else if (data.type.indexOf("建物") !== -1) return "H";
                  case 2:
                    return undefined;
                  default:
                    return undefined;
                }
              })(),
              obj_date_ymd_from: moment(new Date())
                .subtract(2, "years")
                .toDate(),
              obj_date_ymd_to: moment(new Date()).toDate(),
              desc: true,
              pageSize: newData.pageSize,
              frontSite: true,
              page: newData.page,
            },
          });
        } else {
          let auctionsArray = [];
          if (data.auctions?.length > 0) {
            data.auctions.map((item) => {
              auctionsArray.push(item.replace("拍", ""));
            });
          }
          getForeclosures({
            variables: {
              obj_str: data.caseYear ? data.caseYear : undefined,
              obj_share: data.caseIdentity ? data.caseIdentity : undefined,
              obj_caseno: data.caseNumber ? data.caseNumber : undefined,
              obj_court: data.court ? getCourt(data.court) : undefined,
              obj_city: data.district ? [data.district] : undefined,
              obj_area: data.subdistrict ? [data.subdistrict] : undefined,
              obj_address: data.address ? data.address : undefined,
              searchTerm: data.keywords ? data.keywords : undefined,
              obj_date_ymd_from: data.saleDateStart
                ? moment(data.saleDateStart).toDate()
                : undefined,
              obj_date_ymd_to: data.saleDateEnd
                ? moment(data.saleDateEnd).toDate()
                : undefined,
              obj_creat_date_from: data.recentlyAddedStart
                ? moment(data.recentlyAddedStart).toDate()
                : undefined,
              obj_creat_date_to: data.recentlyAddedEnd
                ? moment(data.recentlyAddedEnd).toDate()
                : undefined,
              obj_build_floor_from: data.jianpingStart
                ? Number(data.jianpingStart)
                : undefined,
              obj_build_floor_to: data.jianpingEnd
                ? Number(data.jianpingEnd)
                : undefined,
              obj_price_from: data.unitPriceJianpingStart
                ? Number(data.unitPriceJianpingStart)
                : undefined,
              obj_price_to: data.unitPriceJianpingEnd
                ? Number(data.unitPriceJianpingEnd)
                : undefined,
              obj_type: (() => {
                switch (data.type.length) {
                  case 1:
                    if (data.type.indexOf("土地") !== -1) return "L";
                    else if (data.type.indexOf("建物") !== -1) return "H";
                  case 2:
                    return null;
                  default:
                    break;
                }
              })(),
              obj_patterns: data.typeLand ? data.typeLand : undefined,
              obj_time: auctionsArray.length > 0 ? auctionsArray : undefined,
              obj_transfer: (() => {
                switch (data.pointHand) {
                  case "不分":
                    return undefined;
                  case "不點交":
                    return "0";
                  case "點交":
                    return "1";
                  case "其他":
                    return "2";
                  default:
                    break;
                }
              })(),
              obj_land_data:
                data.landRights === "不分" ? null : data.landRights,
              obj_build_data:
                data.buildRights === "不分" ? null : data.buildRights,
              orderBy: (() => {
                switch (data.sequence) {
                  case "投標日":
                    return "DATE";
                  case "拍次":
                    return "OBJ_TIME";
                  case "底標價":
                    return "OBJ_PRICE";
                  case "案號":
                    return "OBJ_NO";
                  default:
                    break;
                }
              })(),
              desc: true,
              frontSite: true,
              pageSize: newData.pageSize,
              page: newData.page,
            },
          });
        }
      }

      window.scrollTo({
        top: isPhone ? 500 : 700,
        behavior: "smooth",
      });
    }
  }, [data, newData.page]);
  function getAddress(city, area, address) {
    let index;
    let newAddress;
    if (address.includes("路")) {
      index = address.indexOf("路");
    } else if (address.includes("街")) {
      index = address.indexOf("街");
    } else if (address.includes("村")) {
      index = address.indexOf("村");
    }
    newAddress = address.substring(0, index + 1);
    if (
      newAddress.includes(city) ||
      newAddress.includes(area) ||
      newAddress.includes(`台${city.substring(1, 3)}`)
    ) {
      newAddress = newAddress.replace(`台${city.substring(1, 3)}`, "");
      newAddress = newAddress.replace(city, "");
      newAddress = newAddress.replace(area, "");
    }

    return city + area + newAddress;
  }

  function getCaseName(obj_str, obj_share, obj_caseno, obj_another) {
    const share = Array.from(obj_share);
    const condition = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let sourcefnp = false;
    if (share.indexOf("台") > -1 && share.indexOf("金") > -1) {
      sourcefnp = true;
    } else {
      share.forEach((item) => {
        condition.map((item2) => {
          if (item.indexOf(item2) > -1) sourcefnp = true;
        });
      });
    }

    return sourcefnp
      ? obj_str +
          "批號" +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another) +
          "\n"
      : obj_str +
          obj_share +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another) +
          "\n";
  }

  function getPatterns(obj_type, obj_patterns) {
    switch (obj_type) {
      case "L":
        return obj_patterns !== "" ? obj_patterns : "土地";
      case "H":
        return obj_patterns !== "" ? obj_patterns : "建物";
      default:
        return "";
    }
  }

  if (loading || exclusivePropertiesLoading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return dataArray.length > 0 ? (
      <Box my={4}>
        <Container maxWidth="100%">
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant={"h4"} color="textSecondary">
                查詢結果
              </Typography>
            </Grid>
            <Grid item style={{ paddingBotton: "8px" }}>
              <Controller
                render={({ field }) => (
                  <FormControl fullWidth className={classes.fieldBox}>
                    <Select
                      classes={{ root: classes.select }}
                      disableUnderline
                      {...field}
                    >
                      <MenuItem value="" disabled>
                        排列方式
                      </MenuItem>
                      <MenuItem value="一般模式">一般模式</MenuItem>
                      <MenuItem value="列表模式">列表模式</MenuItem>
                    </Select>
                  </FormControl>
                )}
                name={"displayType"}
                control={control}
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ paddingTop: "10px" }}
          >
            {displayType === "一般模式" ? (
              dataArray.map((item) => {
                return (
                  <Grid item xs={isSmPhone ? 12 : 6} sm={6} md={4} lg={3}>
                    <Card className={classes.root}>
                      <CardActionArea>
                        <CardMedia
                          className={classes.media}
                          image={
                            item.images?.length > 0
                              ? item.images[0].imageUrl
                              : item.obj_type === "L"
                              ? "/assets/images/Home/land.jpg"
                              : "/assets/images/Home/choiceProperty.jpg"
                          }
                          onClick={() => {
                            if (franchise) {
                              window.open(
                                `/case/${item.id}`,
                                "_blank",
                                "noopener"
                              );
                              localStorage.setItem(
                                "@fullhouseFranchise",
                                JSON.stringify(`${franchise ? true : false}`)
                              );
                              localStorage.setItem(
                                "@fullhouse-searchType",
                                window.location.search
                              );
                            } else {
                              if (
                                !!localStorage.getItem("@fullhouse-webMemberId")
                              ) {
                                addCheackNumber({
                                  variables: {
                                    id: item.obj_no,
                                    franchise: franchise ? true : false,
                                  },
                                });
                                window.open(
                                  `/case/${item.obj_no}`,
                                  "_blank",
                                  "noopener"
                                );
                                localStorage.setItem(
                                  "@fullhouseFranchise",
                                  `${franchise ? true : false}`
                                );
                                localStorage.setItem(
                                  "@fullhouse-searchType",
                                  window.location.search
                                );
                              } else {
                                Alert.alert("通知", "請先登入才能使用！", [
                                  {
                                    text: "確定",
                                    onPress: () => {
                                      history.replace("/log-in");
                                    },
                                    type: "ok",
                                  },
                                  {
                                    text: "取消",
                                    type: "cancel",
                                  },
                                ]);
                              }
                            }
                          }}
                        />
                        <CardContent style={{ padding: "8px 16px" }}>
                          <Grid container>
                            <Grid item>
                              <Typography
                                gutterBottom
                                variant="h6"
                                component="h2"
                                className={classes.cardTitle}
                                style={{
                                  color: "#dcba54",
                                  fontWeight: "bold",
                                }}
                              >
                                {item.obj_type === "L"
                                  ? item.obj_city +
                                    item.obj_area +
                                    item.obj_section +
                                    "段"
                                  : getAddress(
                                      item.obj_city,
                                      item.obj_area,
                                      item.obj_address
                                    )}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="flex-end">
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  if (franchise) {
                                    return onChangeTab(
                                      `${
                                        item.source === "法拍"
                                          ? courtArray.find(
                                              (item2) =>
                                                item2.value === item.obj_court
                                            )?.label ??
                                            "" +
                                              "(" +
                                              item.obj_str +
                                              item.obj_share +
                                              item.obj_caseno +
                                              ")" +
                                              `${
                                                item.obj_type === "建物"
                                                  ? item.obj_city +
                                                    item.obj_area +
                                                    item.obj_address
                                                  : item.obj_city +
                                                    item.obj_area +
                                                    item.obj_section +
                                                    "段" +
                                                    item.obj_section_s +
                                                    (item.obj_section_s
                                                      ? "小段"
                                                      : "") +
                                                    item.obj_landno +
                                                    (item.obj_landno
                                                      ? "地號"
                                                      : "")
                                              }`
                                          : item.name
                                      }`
                                    );
                                  } else {
                                    history.push("consultation", {
                                      object:
                                        courtArray.find(
                                          (item2) =>
                                            item2.value === item.obj_court
                                        )?.label ??
                                        "" +
                                          "(" +
                                          item.obj_str +
                                          item.obj_share +
                                          item.obj_caseno +
                                          ")" +
                                          `${
                                            item.obj_type === "H"
                                              ? item.obj_city +
                                                item.obj_area +
                                                item.obj_address
                                              : item.obj_city +
                                                item.obj_area +
                                                item.obj_section +
                                                "段" +
                                                item.obj_section_s +
                                                (item.obj_section_s
                                                  ? "小段"
                                                  : "") +
                                                item.obj_landno +
                                                (item.obj_landno ? "地號" : "")
                                          }`,
                                      url: window.location.pathname,
                                    });
                                  }
                                }}
                              >
                                我要諮詢
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid container>
                            {item.obj_type === "H" ? (
                              <Typography
                                variant="body1"
                                color="textSecondary"
                                component="p"
                              >
                                建坪：{item.obj_total_floor.toFixed(2)} 坪
                                {"\u2002"}
                                地坪：{item.obj_land_floor.toFixed(2)}坪
                                <br />
                                保證金：{(item.obj_margin / 10000).toFixed(2)}萬
                                <br />
                                類別：{item.obj_type === "H" ? "建物" : "土地"}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body1"
                                color="textSecondary"
                                component="p"
                              >
                                地坪：{item.obj_land_floor.toFixed(2)}坪
                                <br />
                                保證金：{(item.obj_margin / 10000).toFixed(2)}萬
                                <br />
                                類別：{item.obj_type === "H" ? "建物" : "土地"}
                              </Typography>
                            )}
                          </Grid>
                          <Typography
                            variant="h5"
                            color="primary"
                            align="right"
                            style={{ fontWeight: "bold" }}
                          >
                            {item.obj_price.toFixed(2)}萬
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })
            ) : (
              <Card className={classes.root}>
                <CardContent>
                  <Table
                    data={dataArray ?? []}
                    tableWidth={3}
                    columnWidths={[70, 180, 200, 150, 80, 70, 105, 100, 70, 70]}
                    header={[
                      "編號",
                      "案號\n債務人",
                      "大樓案名\n門牌地址",
                      "日期\n時間",
                      "類別\n狀況",
                      "建坪\n地坪",
                      "建坪／萬\n地坪／萬",
                      "拍賣底價\n保證金",
                      "拍次\n點交",
                      "操作",
                    ]}
                    columns={[
                      (_, index) => (
                        <Grid>
                          <Text>{index + 1}</Text>
                        </Grid>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {getCaseName(
                              item.obj_str,
                              item.obj_share,
                              item.obj_caseno,
                              item.obj_another
                            )}
                          </Text>
                          <Text>
                            {item.obj_debtor.length > 10
                              ? item.obj_debtor.substr(0, 8) + ".."
                              : item.obj_debtor}
                          </Text>
                        </>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {item.obj_city + item.obj_area + "\n"}
                          </Text>
                          {item.obj_type === "H" ? (
                            <Text>
                              {item.obj_city + item.obj_area + item.obj_address}
                            </Text>
                          ) : (
                            <Text>
                              {item.obj_city +
                                item.obj_area +
                                item.obj_section +
                                "段" +
                                item.obj_section_s +
                                (item.obj_section_s ? "小段" : "") +
                                item.obj_landno +
                                (item.obj_landno ? "地號" : "")}
                            </Text>
                          )}
                        </>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {moment(item.obj_date_ymd).format("YYYY-MM-DD") +
                              "\n"}
                          </Text>
                          <Text>
                            {moment(item.obj_date_hi).utc().format("HH:mm")}
                          </Text>
                        </>
                      ),
                      (item) => (
                        <>
                          <Text>
                            {getPatterns(item.obj_type, item.obj_patterns) +
                              "\n"}
                          </Text>
                          {item.obj_stop !== "" && (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                window.open(
                                  `${item.obj_stop_link}`,
                                  "_blank",
                                  "noopener"
                                );
                              }}
                            >
                              停拍公告
                            </Button>
                          )}
                        </>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {item.obj_total_floor + "\n"}
                          </Text>
                          <Text>{item.obj_land_floor}</Text>
                        </>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {item.obj_total_floor === 0
                              ? 0 + "\n"
                              : (item.obj_price / item.obj_total_floor).toFixed(
                                  2
                                ) +
                                "萬" +
                                "\n"}
                          </Text>
                          <Text>
                            {item.obj_land_floor === 0
                              ? 0
                              : (item.obj_price / item.obj_land_floor).toFixed(
                                  2
                                ) + "萬"}
                          </Text>
                        </>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {item.obj_price + "萬" + "\n"}
                          </Text>
                          <Text>
                            {(item.obj_margin / 10000).toFixed(2) + "萬"}
                          </Text>
                        </>
                      ),
                      (item) => (
                        <>
                          <Text color="#22b169">
                            {`${
                              item.obj_time === "0" ? "應買" : item.obj_time
                            }` + "\n"}
                          </Text>
                          <Text>
                            {(() => {
                              switch (item.obj_transfer) {
                                case "0":
                                  return "不點交";
                                case "1":
                                  return "點交";
                                case "2":
                                  return "依公文判斷";
                                default:
                                  break;
                              }
                            })()}
                          </Text>
                        </>
                      ),
                      (item) => (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (franchise) {
                              return onChangeTab(
                                `${
                                  item.source === "法拍"
                                    ? courtArray.find(
                                        (item2) =>
                                          item2.value === item.obj_court
                                      )?.label ??
                                      "" +
                                        "(" +
                                        item.obj_str +
                                        item.obj_share +
                                        item.obj_caseno +
                                        ")" +
                                        `${
                                          item.obj_type === "建物"
                                            ? item.obj_city +
                                              item.obj_area +
                                              item.obj_address
                                            : item.obj_city +
                                              item.obj_area +
                                              item.obj_section +
                                              "段" +
                                              item.obj_section_s +
                                              (item.obj_section_s
                                                ? "小段"
                                                : "") +
                                              item.obj_landno +
                                              (item.obj_landno ? "地號" : "")
                                        }`
                                    : item.name
                                }`
                              );
                            } else {
                              history.push("consultation", {
                                object:
                                  courtArray.find(
                                    (item2) => item2.value === item.obj_court
                                  )?.label ??
                                  "" +
                                    "(" +
                                    item.obj_str +
                                    item.obj_share +
                                    item.obj_caseno +
                                    ")" +
                                    `${
                                      item.obj_type === "H"
                                        ? item.obj_city +
                                          item.obj_area +
                                          item.obj_address
                                        : item.obj_city +
                                          item.obj_area +
                                          item.obj_section +
                                          "段" +
                                          item.obj_section_s +
                                          (item.obj_section_s ? "小段" : "") +
                                          item.obj_landno +
                                          (item.obj_landno ? "地號" : "")
                                    }`,
                                url: window.location.pathname,
                              });
                            }
                          }}
                        >
                          我要諮詢
                        </Button>
                      ),
                    ]}
                    onPress={(item) => {
                      window.open(`/case/${item.obj_no}`, "_blank", "noopener");
                    }}
                  />
                </CardContent>
              </Card>
            )}
            <Grid item container justifyContent="center" xs={12}>
              <Box mt={6}>
                <Pagination
                  count={pageCount ?? 1}
                  color="primary"
                  size="large"
                  page={newData.page}
                  onChange={(e, n) => changeData("page", n, true)}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    ) : (
      <Box my={4}>
        <Container maxWidth="lg">
          <Grid container justifyContent="center">
            <Typography variant={isPhone ? "h4" : "h4"} color="textSecondary">
              查無資料
            </Typography>
          </Grid>
        </Container>
      </Box>
    );
  }
}
